import * as moment from 'moment';

export class projectNumber{

  isValidProjectNumber(projNumber: string): boolean {

    if(projNumber.length != 11) {
      console.log('ERROR: length of Project number needs to be 11!');
      return false;
    }

    let day = Number(projNumber.substr(0,2));
    let month = Number(projNumber.substr(2,2));
    let year = Number(projNumber.substr(4,2));
    let id = projNumber.substr(6,3);
    let controldigitOne = Number(projNumber.substr(9,1));
    let controldigitTwo = Number(projNumber.substr(10,1));

    console.log('Day: ' + day +
                ' Month: ' + month +
                ' Year: ' + year +
                ' id: ' + id +
                ' control digit one: ' + controldigitOne +
                ' control digit two: ' + controldigitTwo +
                ' monthindex: ' + [1,2,3,4,5,6,7,8,9,10,11,12].indexOf(month)
    );

    //First check dates
    if ([1,3,5,7,8,10,12].indexOf(month) !== -1  && (( 1 <= day ) && ( day <= 31)) ){
      console.log('31 day month ' + month + '/' + day);
      // return true;
    }
    else if ([4,6,9,11].indexOf(month) !== -1 && (( 1 <= day ) || ( day <= 30)) ) {
      console.log('30 day month ' + month + '/' + day);
      // return true;
    }
    else if ([2].indexOf(month) !== -1 && ( 1 <= day ) && ( day <= 29) ){
      console.log('February ' + year + '/' + month + '/' + day);

      if(!(year % 4 === 0 && year % 100 !== 0) || year % 400 === 0) {
        console.log('we are in a irregular leap year' + year);
       if ( day === 29 ) return false;
      }
      // else return true;
    }

    //maths behind control numbers

    let d1 = Number(projNumber.substr(0,1));
    let d2 = Number(projNumber.substr(1,1));
    let m1 = Number(projNumber.substr(2,1));
    let m2 = Number(projNumber.substr(3,1));
    let y1 = Number(projNumber.substr(4,1));
    let y2 = Number(projNumber.substr(5,1));
    let i1 = Number(projNumber.substr(6,1));
    let i2 = Number(projNumber.substr(7,1));
    let i3 = Number(projNumber.substr(8,1));


    let k1 = 11 - (((3 * d1) + (7 * d2) + (6 * m1) + m2 + (8 * y1) +
      (9 * y2) + (4 * i1) + (5 * i2) + (2 * i3)) % 11);
    let u1 = k1 === 11 ? 0 : k1;
    let k2 = 11 - (((5 * d1) + (4 * d2) + (3 * m1) + (2 * m2) + (7 * y1) +
      (6 * y2) + (5 * i1) + (4 * i2) + (3 * i3) + (2 * u1)) % 11);
    let u2 = k2 === 11 ? 0 : k2;

    console.log(
      'd1: ' + d1 +
      ' d2: ' + d2 +
      ' m1: ' + m1 +
      ' m2: ' + m2 +
      ' y1: ' + y1 +
      ' y2: ' + y2 +
      ' i1: ' + i1 +
      ' i2: ' + i2 +
      ' i3: ' + i3 +
      ' control digit one: ' + controldigitOne +
      ' control digit two: ' + controldigitTwo +
      ' u1: ' + u1 +
      ' u2: ' + u2
    );


    return u1 === controldigitOne && u2 === controldigitTwo;
  }

  getProjectNo(date: Date, num: number): string {

    moment.locale('en-AU');
    console.log('input date: ' + moment(date).format('L').toString() );

    if (num === null || num === 0) {
      num =1;
      console.log('project number was zero/null - set to 1');
    }

    let projDate = moment(date).date().toString();
    let projMonth = (moment(date).month()+1).toString();
    let projYear = moment(date).year().toString();

    console.log('input date transformed: ' +projDate + '/' + projMonth + '/' + projYear);

    if (moment(date).date() < 10 ) projDate = '0' + projDate;
    if (moment(date).month() < 10 ) projMonth = '0' + projMonth;
    if (moment(date).year() < 10 ) projYear = '0' + projYear;

    let projNumber = num.toString();

    if( num < 10 ) {
      projNumber = '00' + projNumber;
    }
    else if (num < 100) {
      projNumber = '0' + projNumber;
    }

    console.log('Date: ' + projDate + '/' + projMonth + '/'
      + projYear + ' projNumber: ' + projNumber);


    let d1 = Number(projDate.substr(0,1));
    let d2 = Number(projDate.substr(1,1));
    let m1 = Number(projMonth.substr(0,1));
    let m2 = Number(projMonth.substr(1,1));
    let y1 = Number(projYear.substr(2,1));
    let y2 = Number(projYear.substr(3,1));
    let i1 = Number(projNumber.substr(0,1));
    let i2 = Number(projNumber.substr(1,1));
    let i3 = Number(projNumber.substr(2,1));


    let k1 = 11 - (((3 * d1) + (7 * d2) + (6 * m1) + m2 + (8 * y1) +
      (9 * y2) + (4 * i1) + (5 * i2) + (2 * i3)) % 11);
    let u1 = k1 === 11 ? 0 : k1;
    let k2 = 11 - (((5 * d1) + (4 * d2) + (3 * m1) + (2 * m2) + (7 * y1) +
      (6 * y2) + (5 * i1) + (4 * i2) + (3 * i3) + (2 * u1)) % 11);
    let u2 = k2 === 11 ? 0 : k2;

    console.log(
      'd1: ' + d1 +
      ' d2: ' + d2 +
      ' m1: ' + m1 +
      ' m2: ' + m2 +
      ' y1: ' + y1 +
      ' y2: ' + y2 +
      ' i1: ' + i1 +
      ' i2: ' + i2 +
      ' i3: ' + i3 +
      ' u1: ' + u1 +
      ' u2: ' + u2
    );

    return d1.toString() +
      d2.toString() +
      m1.toString() +
      m2.toString() +
      y1.toString() +
      y2.toString() +
      i1.toString() +
      i2.toString() +
      i3.toString() +
      u1.toString() +
      u2.toString();
  }

}


// WEBPACK FOOTER //
// ./src/app/core/projectNumber.ts